import axios from "axios";
import { createPaginatedStateWithSummary, handlePaginatedResponse, createFilterState, createPaginatedState } from '../helpers/paginationState';

export const state = {
    spoilt: [],
    stock_movements: createPaginatedStateWithSummary(50, { total_in: 0, total_out: 0, total_balance: 0 }),
    supplier_list: [],
    supplier_deposits: [],
    lpo: [],
    lpos: [],
    lpo_cart: [],
    lpo_receive_cart: [],
    lpo_receive_cart_tot: "",
    stock_cart: [],
    short_expiries: createPaginatedState(),
    expired_stock: createPaginatedState(),
    reconciliation_report: createPaginatedState(),
    reconciliation_report_details: [],
    total_shop_cart: "",
    save_status: false,
    purchaseId: '',
    pendingspoilt: createPaginatedState(),
    rejectedspoilt: createPaginatedState(),
    price_change: createPaginatedState(),
    supplier_balances: [],
    supplier_balances_paginated: createPaginatedStateWithSummary(50, { total_balance: 0 }),
    current_supplier_balances_filters: createFilterState({
        type: 'creditors',
        search: ''
    }),
    supplier_balances_filter_status: false,
    supplier_balancedetails: [],
    batches: [],
    filter_status: false,
    reconciliation_report_summary_paginated: createPaginatedStateWithSummary(50, { total_variance_amount: 0 }),
    unreconciled_items: createPaginatedState(),
    spoilt_paginated: createPaginatedStateWithSummary(50, { total_value: 0 }),
    current_spoilt_filters: createFilterState({
        search: '',
        branch_id: 0,
        category: 1
    }),
    pendingspoilt_consumables: createPaginatedState(),
    rejectedspoiltconsumables: createPaginatedState(),

};

export const getters = {
    Spoilt: state => state.spoilt.data,
    PendingSpoilt: state => state.pendingspoilt.data,
    PendingSpoiltPagination: state => state.pendingspoilt.meta,
    IsPendingSpoiltServerPaginated: state => state.pendingspoilt.isServerPaginated,
    PendingSpoiltSummary: state => state.pendingspoilt.summary,

    PendingSpoiltConsumables: state => state.pendingspoilt_consumables.data,
    PendingSpoiltConsumablesPagination: state => state.pendingspoilt_consumables.meta,
    IsPendingSpoiltConsumablesServerPaginated: state => state.pendingspoilt_consumables.isServerPaginated,
    PendingSpoiltConsumablesPaginated: state => state.pendingspoilt_consumables.data,


    RejectedSpoiltPagination: state => state.rejectedspoilt.meta,
    IsRejectedSpoiltServerPaginated: state => state.rejectedspoilt.isServerPaginated,
    RejectedSpoilt: state => state.rejectedspoilt.data,
    Suppliers: state => state.supplier_list.data,
    SupplierDeposits: state => state.supplier_deposits.data,
    TotalShopCart: state => state.total_shop_cart,
    StockCart: state => state.stock_cart.data,
    StockMovement: state => state.stock_movements.data,
    StockMovementPagination: state => state.stock_movements.meta,
    IsStockMovementPaginated: state => state.stock_movements.isServerPaginated,
    StockMovementSummary: state => state.stock_movements.summary,
    LPOReceiveCart: state => state.lpo_receive_cart.data,
    LPOReceiveCartTot: state => state.lpo_receive_cart_tot,
    LPOCart: state => state.lpo_cart.data,
    LPOs: state => state.lpos.data,
    LPO: state => state.lpo.data,
    ShortExpiries: state => state.short_expiries.data,
    ShortExpiriesPagination: state => state.short_expiries.meta,
    IsShortExpiriesServerPaginated: state => state.short_expiries.isServerPaginated,
    ShortExpiriesPaginated: state => state.short_expiries.data,
    ReconciliationReport: state => state.reconciliation_report.data,
    ReconciliationReportPagination: state => state.reconciliation_report.meta,
    ReconciliationReportSummary: state => state.reconciliation_report.summary,
    IsReconciliationReportServerPaginated: state => state.reconciliation_report.isServerPaginated,
    ReconciliationReportPaginated: state => state.reconciliation_report.data,
    ReconciliationReportDetails: state => state.reconciliation_report_details.data,
    SaveStatus: state => state.save_status,
    PurchaseId: state => state.purchaseId,
    PriceChange: state => state.price_change.data,
    PriceChangePagination: state => state.price_change.meta,
    PriceChangePaginated: state => state.price_change.isServerPaginated,
    IsPriceChangeServerPaginated: state => state.price_change.data,
    SuppliersBalances: state => state.supplier_balances,
    SupplierBalancesPaginated: state => state.supplier_balances_paginated.data,
    SupplierBalancesPagination: state => state.supplier_balances_paginated.meta,
    IsSupplierBalancesServerPaginated: state => state.supplier_balances_paginated.isServerPaginated,
    SupplierBalancesSummary: state => state.supplier_balances_paginated.summary,
    SupplierBalancesFilterStatus: state => state.supplier_balances_filter_status,
    SuppliersBalanceDetails: state => state.supplier_balancedetails.data,
    Batches: state => state.batches.data,
    FilterStatus: state => state.filter_status,

    ReconciliationReportSummaryPaginated: state => state.reconciliation_report_summary_paginated.data,
    ReconciliationReportSummaryPagination: state => state.reconciliation_report_summary_paginated.meta,
    IsReconciliationReportSummaryServerPaginated: state => state.reconciliation_report_summary_paginated.isServerPaginated,
    ReconciliationReportSummarySummary: state => state.reconciliation_report_summary_paginated.summary,
    CurrentReconciliationSummaryFilters: state => state.current_reconciliation_summary_filters,
    UnreconciledItemsPagination: state => state.unreconciled_items.meta,
    UnreconciledItemsPaginated: state => state.unreconciled_items.data,
    IsUnreconciledItemsServerPaginated: state => state.unreconciled_items.isServerPaginated,
    UnreconciledItems: state => state.unreconciled_items.data,
    UnreconciledItemsSummary: state => state.unreconciled_items.summary,
    SpoiltPaginated: state => state.spoilt_paginated.data,
    SpoiltPagination: state => state.spoilt_paginated.meta,
    IsSpoiltServerPaginated: state => state.spoilt_paginated.isServerPaginated,
    SpoiltSummary: state => state.spoilt_paginated.summary,
    CurrentSpoiltFilters: state => state.current_spoilt_filters,

    ExpiredStock: state => state.expired_stock.data,
    ExpiredStockPagination: state => state.expired_stock.meta,
    IsExpiredStockServerPaginated: state => state.expired_stock.isServerPaginated,
    ExpiredStockPaginated: state => state.expired_stock.data,
    RejectedSpoiltConsumables: state => state.rejectedspoiltconsumables.data,
    RejectedSpoiltConsumablesPagination: state => state.rejectedspoiltconsumables.meta,
    RejectedSpoiltConsumablesPaginated: state => state.rejectedspoiltconsumables.data,
    IsRejectedSpoiltConsumablesServerPaginated: state => state.rejectedspoiltconsumables.isServerPaginated,

};

export const mutations = {
    SET_STOCK_MOVEMENTS(state, response) {
        handlePaginatedResponse(state.stock_movements, response);
    },
    SET_SPOILT(state, response) {
        handlePaginatedResponse(state.spoilt, response);
    },
    SET_PENDINGSPOILT(state, response) {
        handlePaginatedResponse(state.pendingspoilt, response);
    },
    SET_PENDINGSPOILT_CONSUMABLES(state, response) {
        handlePaginatedResponse(state.pendingspoilt_consumables, response);
    },
    SET_REJECTEDSPOILT(state, response) {
        handlePaginatedResponse(state.rejectedspoilt, response);
    },
    SET_RECONCILIATION_REPOPRT(state, response) {
        handlePaginatedResponse(state.reconciliation_report, response);
    },
    SET_RECONCILIATION_REPOPRT_DETAILS(state, newValue) {
        state.reconciliation_report_details = newValue
    },
    SET_SHORT_EXPIRIES(state, response) {
        handlePaginatedResponse(state.short_expiries, response);
    },
    SET_EXPIRED(state, response) {
        handlePaginatedResponse(state.expired_stock, response);

    },
    SET_SUPPLIERS(state, newValue) {
        state.supplier_list = newValue
    },
    SET_SUPPLIER_DEPOSITS(state, newValue) {
        state.supplier_deposits = newValue
    },
    SET_SAVE_STATUS(state, newValue) {
        state.save_status = newValue
    },
    SET_LPO_CART(state, newValue) {
        state.lpo_cart = newValue
    },
    SET_LPO_RECEIVE_CART(state, newValue) {
        state.lpo_receive_cart = newValue
    },
    SET_LPO_RECEIVE_CART_TOT(state, newValue) {
        state.lpo_receive_cart_tot = newValue
    },
    SET_LPOS(state, newValue) {
        state.lpos = newValue
    },
    SET_LPO(state, newValue) {
        state.lpo = newValue
    },
    SET_STOCK_CART(state, newValue) {
        state.stock_cart = newValue
    },
    SET_TOTAL_SHOP_CART(state, newValue) {
        state.total_shop_cart = newValue
    },
    SET_PURCHASES_ID(state, newValue) {
        state.purchaseId = newValue
    },
    SET_PRICE_CHANGE(state, response) {
        handlePaginatedResponse(state.price_change, response);
    },
    SET_SUPPLIER_BALANCES(state, newValue) {
        state.supplier_balances = newValue
    },
    SET_SUPPLIER_BALANCEDETAILS(state, newValue) {
        state.supplier_balancedetails = newValue
    },
    SET_BATCHES(state, newValue) {
        state.batches = newValue
    },
    SET_FILTER_STATUS(state, newValue) {
        state.filter_status = newValue
    },
    SET_RECONCILIATION_REPORT_SUMMARY_PAGINATED(state, response) {
        handlePaginatedResponse(state.reconciliation_report_summary_paginated, response);
    },
    UPDATE_CURRENT_RECONCILIATION_SUMMARY_FILTERS(state, filters) {
        state.current_reconciliation_summary_filters = { ...state.current_reconciliation_summary_filters, ...filters };
    },
    UPDATE_CURRENT_UNRECONCILED_FILTERS(state, filters) {
        state.current_unreconciled_filters = { ...state.current_unreconciled_filters, ...filters };
    },
    SET_UNRECONCILED_ITEMS(state, response) {
        handlePaginatedResponse(state.unreconciled_items, response);
    },
    SET_SPOILT_PAGINATED(state, response) {
        handlePaginatedResponse(state.spoilt_paginated, response);
    },
    UPDATE_CURRENT_SPOILT_FILTERS(state, filters) {
        state.current_spoilt_filters = { ...state.current_spoilt_filters, ...filters };
    },
     SET_SUPPLIER_BALANCES_FILTER_STATUS(state, newValue) {
        state.supplier_balances_filter_status = newValue;
    },
    SET_SUPPLIER_BALANCES_PAGINATED(state, response) {
        handlePaginatedResponse(state.supplier_balances_paginated, response);
    },
};

export const actions = {
    fetchPendingSpoilt({ commit }, payload) {
        axios.post('pending', payload).then(ec_res => {
            commit('SET_PENDINGSPOILT', ec_res.data)
        })
    },

    addSpoilt({ commit, dispatch, state }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('spoilt_stock', payload).then(() => {
            payload.category == 2 ? dispatch( 'consumables/fetchSpoiltConsumables',{ root: true }) : dispatch('fetchSpoiltData', state.current_spoilt_filters);
            let message = { 'msg': `${payload.quantity} item(s) of Product ${payload.name} await confirmation as spoilt ` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Confirm Spoilt Stock
    ConfirmSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('confirmspoilt_stock', payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully confirmed` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Confirming Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Reject Spoilt Stock
    RejectSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('rejectspoilt_stock', payload).then(() => {
            dispatch('fetchPendingSpoilt');
            let message = { 'msg': `item ${payload.name} spoilt stock record has been successfully rejected` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Rejecting Spoilt Stock " }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteSpoilt({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`spoilt_stock/${payload.id}`).then(() => {
            dispatch('fetchSpoilt');
            let message = { 'msg': `Spoilt stock record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchSpoiltData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        commit('UPDATE_CURRENT_SPOILT_FILTERS', apiPayload);
        axios.post('fetch_spoiltstock', apiPayload)
            .then(response => {
                commit('SET_SPOILT_PAGINATED', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_SPOILT_PAGINATED', { data: [], meta: {}, summary: { total_value: 0 } });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load spoilt stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },
    fetchSpoilt({ commit }) {
        axios.get('spoilt_stock').then(ec_res => {
            commit('SET_SPOILT', ec_res.data)
        })
    },
    // Fetch Pending Spoilt Stock
    fetchPendingSpoiltConsumables({ commit, dispatch }, payload = {}) {
        commit('SET_SAVE_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        axios.get('pending_consumable', { params: apiPayload })
            .then(response => {
                commit('SET_PENDINGSPOILT_CONSUMABLES', response.data);
                commit('SET_SAVE_STATUS', false);
            })
            .catch((error) => {
                commit('SET_PENDINGSPOILT_CONSUMABLES', { data: [], meta: {} });
                commit('SET_SAVE_STATUS', false);
                let errorMsg = 'Failed to load pending spoilt stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },
    // Fetch Rejected Spoilt Stock
    fetchRejectedSpoilt({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        axios.get('rejected', { params: apiPayload })
            .then(response => {
                commit('SET_REJECTEDSPOILT', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_REJECTEDSPOILT', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load rejected spoilt stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },
    // Fetch Rejected Spoilt Stock
    fetchRejectedSpoiltConsumables({ commit, dispatch }, payload = {}) {
        commit('SET_SAVE_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        axios.get('rejected_spoilt_consumables', { params: apiPayload })
            .then(response => {
                commit('SET_REJECTEDSPOILT', response.data);
                commit('SET_SAVE_STATUS', false);
            })
            .catch((error) => {
                commit('SET_REJECTEDSPOILT', { data: [], meta: {} });
                commit('SET_SAVE_STATUS', false);
                let errorMsg = 'Failed to load rejected spoilt stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },
    //   ADD SUPPLIER
    addSupplier({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('suppliers', payload).then(() => {
            dispatch('fetchSuppliers');
            let message = { 'msg': `Supplier ${payload.name} added successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Supplier " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Supplier
    editSupplier({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`suppliers/${payload.id}`, payload).then(() => {
            dispatch('fetchSuppliers');
            let message = { 'msg': `Supplier ${payload.name} updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Supplier" }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete Supplier
    deleteSupplier({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`suppliers/${payload.id}`).then(() => {
            dispatch('fetchSuppliers');
            let message = { 'msg': `Supplier ${payload.name} deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // add products to shop cart
    addToCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('shop_purchase_cart', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            if (response.status != 200) {
                let message = { 'msg': "Failed to add Product to cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`shop_purchase_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            if (response.status == 200) {
                let message = { 'msg': "Purchase cart edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCart({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`shop_purchase_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' deleting failed' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process purchase and print
    savePurchasePrint({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`shop_purchases`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            if (response.status == 200) {
                if (response.data.message != '') {
                    let message = { 'msg': response.data.message }
                    dispatch('notification/error', message, { root: true })
                }
                commit('SET_PURCHASES_ID', response.data.id)
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process purchase and Exit
    savePurchaseExit({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`shop_purchases`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            if (response.status == 200) {
                if (response.data.message != '') {
                    let message = { 'msg': response.data.message }
                    dispatch('notification/error', message, { root: true })
                } else {
                    let message = { 'msg': "Purchase Recorded successfully" }
                    dispatch('notification/success', message, { root: true })
                }
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Purchase" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchCart')
            dispatch('fetchTotShopCart')
            let message = { 'msg': "Failed to record Purchase" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // remove expired stock
    removeExpired({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('mark_as_expired', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchExpiredStock')
            if (response.status == 200) {
                let message = { 'msg': "Product successfully marked as expired" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Operation was unsuccessful" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to mark Product as Expired" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // LPO
    // add products to lpo cart
    addToCartLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('lpo_cart', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOCart')
            if (response.status == 201) {
                let message = { 'msg': "Item already exists in cart" }
                dispatch('notification/error', message, { root: true })
            } else if (response.status != 201 && response.status != 200) {
                let message = { 'msg': "Error in adding to cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product to Cart" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCartLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`lpo_cart/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOCart')
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCartLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`lpo_cart/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOCart')
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': 'Failed to delete Product from cart' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Add LPO Product
    addLPOProduct({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('lpo_product', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPODetails', data.id)
            if (response.status == 200) {
                let message = { 'msg': "LPO Product added successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to add LPO Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': 'LPO Product adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Delete LPO
    deleteAllLPO({ dispatch, commit }, id) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`lpo_delete/${id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOs')
            if (response.status == 200) {
                let message = { 'msg': "LPO deleted successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete LPO" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': 'Failed to delete LPO' }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Process purchase order
    savePurchaseOrder({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`lpos`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOCart')
            if (response.status == 200) {
                let message = { 'msg': "Purchase Order Recorded successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to record Purchase Order" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record Purchase Order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`lpos/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPODetails', data.lpo)
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`lpos/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPODetails', data.lpo)
            if (response.status == 200) {
                let message = { 'msg': "LPO deleted successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete LPO" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to delete LPO" }
            dispatch('notification/error', message, { root: true })
        })
    },

    //aprove LPO
    approveLPO({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`lpo_status/${data.id}`).then(() => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPOs')
            let message = { 'msg': "LPO approved successfully" }
            dispatch('notification/success', message, { root: true })

        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to approve LPO" }
            dispatch('notification/error', message, { root: true })
        })
    },

    LPOPayment({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('lpo_payment', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPODetails', response.data.id)
            if (response.status == 200) {
                let message = { 'msg': "Payment added successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to add Payment" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Payment" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Receiving lpo items
    // LPO
    // add products to lpo cart
    addToCartLpoReceive({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post('lpo_receive', data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch("fetchLpoReceiveCart", data.lpoId)
            dispatch('fetchLpoReceiveCartTot', data.lpoId)
            if (response.status == 200) {
                let message = { 'msg': "Product added to cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Item already exists in cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to add Product to Cart" }
            dispatch('notification/error', message, { root: true })
        })
    },

    editCartLpoReceive({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`lpo_receive/${data.id}`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch("fetchLpoReceiveCart", data.lpo)
            dispatch('fetchLpoReceiveCartTot', data.lpo)
            if (response.status == 200) {
                let message = { 'msg': "Product edited successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to edit Product" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to edit Product" }
            dispatch('notification/error', message, { root: true })
        })
    },

    deleteCartLpoReceive({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.delete(`lpo_receive/${data.id}`).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch("fetchLpoReceiveCart", data.lpo)
            dispatch('fetchLpoReceiveCartTot', data.lpo)
            if (response.status == 200) {
                let message = { 'msg': "Product deleted from cart successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to delete Product from cart" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': data.name + ' adding failed' }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Process purchase order
    ReceivePurchaseOrder({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.post(`lpo_purchase`, data).then(response => {
            commit('SET_SAVE_STATUS', false)
            dispatch('fetchLPODetails', data.lpo)
            dispatch("fetchLpoReceiveCart", data.lpo)
            dispatch('fetchLpoReceiveCartTot', data.lpo)
            if (response.status == 200) {
                let message = { 'msg': "Purchase Order Processed successfully" }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                let message = { 'msg': "Failed to Processing Purchase Order" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to record Purchase Order" }
            dispatch('notification/error', message, { root: true })
        })
    },

    //  edit stock buying price
    editBPrice({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`update_buyingPrice/${payload.id}`, payload).then(() => {
            payload.filterProducts ? dispatch('products/viewProducts', payload.filterProducts, { root: true }) : dispatch('products/fetchProductsData', null, { root: true });
            let message = { 'msg': `Buying Price Amount  updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Buying Price" }
            dispatch('notification/error', message, { root: true })
        })
    },

    //  edit stock average buying price
    editAverageBPrice({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`update_averageBuyingPrice/${payload.id}`, payload).then(() => {
            payload.filterProducts ? dispatch('products/viewProducts', payload.filterProducts, { root: true }) : dispatch('products/fetchProductsData', null, { root: true });
            let message = { 'msg': `Buying Price Amount  updated successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Buying Price" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // add Supplier deposit
    addSupplierDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.post('supplier_deposit', payload).then(() => {
            dispatch('fetchSupplierDeposits');
            let message = { 'msg': ` Supplier deposit of ${payload.amount}  recorded successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error Adding Supplier Deposit " }
            dispatch('notification/error', message, { root: true })
        })
    },
    // Edit Supplier Deposit
    editSupplierDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`supplier_deposit/${payload.id}`, payload).then(() => {
            dispatch('fetchSupplierDeposits');
            let message = { 'msg': `Supplier Deposit Updated Successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error updating Supplier Deposit " + error }
            dispatch('notification/error', message, { root: true })
        })
    },
    // delete Supplier deposit
    deleteSupplierDeposit({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.delete(`supplier_deposit/${payload.id}`).then(() => {
            dispatch('fetchSupplierDeposits');
            let message = { 'msg': `Supplier Deposit  record deleted successfully` }
            dispatch('notification/success', message, { root: true })
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Edit Stock Details
    editStock({ dispatch, commit }, data) {
        commit('SET_SAVE_STATUS', true)
        axios.put(`edit_stock/${data.id}`, data).then(response => {
            if (response.status == 200) {
                commit('SET_SAVE_STATUS', false)
                data.filterProducts ? dispatch('products/viewProducts', data.filterProducts, { root: true }) : dispatch('products/fetchProductsData', null, { root: true });
                let message = { 'msg': `Stock details updated successfully` }
                dispatch('notification/success', message, { root: true })
            } else if (response.status == 201) {
                commit('SET_SAVE_STATUS', false)
                let message = { 'msg': "Failed to update stock details" }
                dispatch('notification/error', message, { root: true })
            }
        }).catch(() => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Failed to update stock details" }
            dispatch('notification/error', message, { root: true })
        })
    },

    // Fetch Supplier Deposits
    fetchSupplierDeposits({ commit }) {
        axios.get('supplier_deposit').then(ec_res => {
            commit('SET_SUPPLIER_DEPOSITS', ec_res.data)
        })
    },

    fetchSupplierDepositDetails({ commit }, id) {
        axios.put(`supplierdeposit_details/${id}`).then(ec_res => {
            commit('SET_SUPPLIER_DEPOSITS', ec_res.data)
        })
    },

    fetchSuppliers({ commit }) {
        axios.get(`suppliers`).then(ec_res => {
            commit('SET_SUPPLIERS', ec_res.data)
        })
    },

    fetchCart({ commit }) {
        axios.get('shop_purchase_cart').then(cart => {
            commit('SET_STOCK_CART', cart.data)
        })
    },

    fetchTotShopCart({ commit }) {
        axios.get('total_shop_cart').then(total => {
            commit('SET_TOTAL_SHOP_CART', total.data)
        })
    },

    fetchLPOCart({ commit }) {
        axios.get('lpo_cart').then(cart => {
            commit('SET_LPO_CART', cart.data)
        })
    },

    fetchLPOs({ commit }) {
        axios.get('lpos').then(cart => {
            commit('SET_LPOS', cart.data)
        })
    },
    fetchLPODetails({ commit }, id) {
        axios.get(`lpos/${id}`).then(cart => {
            commit('SET_LPO', cart.data)
        })
    },
    fetchLpoReceiveCart({ commit }, id) {
        axios.get(`lpo_receive/${id}`).then(cart => {
            commit('SET_LPO_RECEIVE_CART', cart.data)
        })
    },
    fetchLpoReceiveCartTot({ commit }, id) {
        axios.get(`lpo_receive_tot/${id}`).then(cart => {
            commit('SET_LPO_RECEIVE_CART_TOT', cart.data)
        })
    },

    fetchShortExpiries({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        axios.get('short_expiries', { params: apiPayload })
            .then(response => {
                commit('SET_SHORT_EXPIRIES', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_SHORT_EXPIRIES', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load short expiries stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },

    fetchExpiredStock({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            search: payload.search ?? '',
            branch_id: payload.branch_id ?? 0,
            category: payload.category ?? 1
        };
        axios.get('expired', { params: apiPayload })
            .then(response => {
                commit('SET_EXPIRED', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_EXPIRED', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load expired stock.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },
    fetchReconciliationReport({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true)
        let apiPayload = { ...payload };
        apiPayload.page = payload.page ?? 1;
        apiPayload.per_page = payload.per_page ?? 50;
        axios.post('reconcile', apiPayload).then(response => {
            commit('SET_RECONCILIATION_REPOPRT', response.data);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_RECONCILIATION_REPOPRT', { data: [], meta: {} });
            commit('SET_SAVE_STATUS', false);
            let errorMsg = 'Failed to load reconciliation report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },


    fetchReconciliationReportDetails({ commit }, id) {
        axios.get(`reconcile/${id}`).then(total => {
            commit('SET_RECONCILIATION_REPOPRT_DETAILS', total.data)
        })
    },

    fetchStockMovements({ commit }, id) {
        axios.get(`stock_movement/${id}`).then(cart => {
            commit('SET_STOCK_MOVEMENTS', cart.data)
        })
    },

    fetchStockMovementsPaginated({ commit, dispatch }, payload = {}) {
        commit('SET_SAVE_STATUS', true);
        const apiPayload = {
            id: payload.id,
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            type: payload.type !== undefined ? payload.type : '',
            datefrom: payload.dfrom ?? '',
            dateto: payload.dto ?? '',
            search: payload.search ?? ''
        };

        axios
            .get(`stock_movement/${payload.id}`, { params: apiPayload })
            .then((response) => {
                commit('SET_STOCK_MOVEMENTS', response.data);
                commit('SET_SAVE_STATUS', false);
            })
            .catch(() => {
                commit('SET_STOCK_MOVEMENTS', { data: [], meta: {}, summary: { total_in: 0, total_out: 0, total_balance: 0 } });
                commit('SET_SAVE_STATUS', false);
                let errorMsg = 'Failed to load stock movements.';
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });

    },

    // Fetch Price Changes
    fetchPriceChanges({ commit, dispatch }, payload = {}) {
        commit('SET_SAVE_STATUS', true)
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            product: payload.product ?? '',
            branch_id: payload.branch_id ?? 0,
            datefrom: payload.datefrom ?? '',
            dateto: payload.dateto ?? ''
        };
        axios.get('shopprice_change', { params: apiPayload }).then(response => {
            commit('SET_PRICE_CHANGE', response.data);
            commit('SET_SAVE_STATUS', false);
        }).catch(() => {
            commit('SET_RECONCILSET_PRICE_CHANGEIATION_REPOPRT', { data: [], meta: {} });
            commit('SET_SAVE_STATUS', false);
            let errorMsg = 'Failed to load price change report.';
            dispatch('notification/error', { msg: errorMsg }, { root: true });
        });
    },

    // supplier balances
    fetchSuppliersBalances({ commit }) {
        axios.get('supplier_balances').then(ec_res => {
            commit('SET_SUPPLIER_BALANCES', ec_res.data)
        })
    },

    fetchSupplierBalancesData({ commit, state }, payload = {}) {
        commit('SET_SUPPLIER_BALANCES_FILTER_STATUS', true);
        const filters = { ...state.current_supplier_balances_filters, ...payload };
        const params = new URLSearchParams(filters).toString();
        const apiUrl = `supplier_balances?${params}`;

        axios.get(apiUrl)
            .then(response => {
                commit('SET_SUPPLIER_BALANCES_PAGINATED', response.data);
                commit('SET_SUPPLIER_BALANCES_FILTER_STATUS', false);
            })
            .catch(() => {
                commit('SET_SUPPLIER_BALANCES_PAGINATED', { data: [], meta: {} });
                commit('SET_SUPPLIER_BALANCES_FILTER_STATUS', false);
            });
    },


    // supplier balances details
    fetchSuppliersBalanceDetails({ commit }, payload) {
        commit('SET_FILTER_STATUS',true)
        axios.post('supplier_balancedetails',payload).then(ec_res => {
            commit('SET_SUPPLIER_BALANCEDETAILS', ec_res.data)
            commit('SET_FILTER_STATUS',false)
        })
    },

    fetchDescriptiveSuppliersBalanceDetails({ commit }, id) {
        axios.get(`descriptive_supplierbalancedetails/${id}`).then(ec_res => {
            commit('SET_SUPPLIER_BALANCEDETAILS', ec_res.data)
        })
    },


    // supplier balances details
    fetchBatches({ commit }, data) {
        commit('SET_FILTER_STATUS', true)
        axios.post('batchesdata', data).then(ec_res => {
            commit('SET_FILTER_STATUS', false)
            commit('SET_BATCHES', ec_res.data)
        })
    },

    // Synchronise Reconciliation
    SynchronizeReconciliation({ commit, dispatch }, payload) {
        commit('SET_SAVE_STATUS', true);
        axios.put(`synchronize_reconciliation/${payload.id}`, payload).then(() => {
            let message = { 'msg': `Reconciliation synchronized successfully` }
            dispatch('notification/success', message, { root: true })
            dispatch('products/viewProducts', payload.filterdata);
            commit('SET_SAVE_STATUS', false);
        }).catch((error) => {
            commit('SET_SAVE_STATUS', false)
            let message = { 'msg': "Error in synchronizing reconciliation " + error }
            dispatch('notification/error', message, { root: true })
        })
    },

    fetchReconciliationReportSummaryData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            category: payload.category ?? '',
            product: payload.product ?? '',
            branch_id: payload.branch_id ?? 0,
            datefrom: payload.datefrom ?? '',
            dateto: payload.dateto ?? ''
        };
        commit('UPDATE_CURRENT_RECONCILIATION_SUMMARY_FILTERS', apiPayload);

        axios.post('reconciliation_summary', apiPayload)
            .then(response => {
                commit('SET_RECONCILIATION_REPORT_SUMMARY_PAGINATED', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_RECONCILIATION_REPORT_SUMMARY_PAGINATED', {
                    data: [],
                    meta: {},
                    summary: {
                        total_variance_amount: 0,
                    }
                });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load reconciliation summary report.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },


    fetchUnReconciledItemsData({ commit, dispatch }, payload = {}) {
        commit('SET_FILTER_STATUS', true);
        const apiPayload = {
            page: payload.page ?? 1,
            per_page: payload.per_page ?? 50,
            product: payload.product ?? '',
            datefrom: payload.datefrom ?? '',
            dateto: payload.dateto ?? ''
        };
        commit('UPDATE_CURRENT_UNRECONCILED_FILTERS', apiPayload);

        axios.post('unreconciled_items', apiPayload)
            .then(response => {
                commit('SET_UNRECONCILED_ITEMS', response.data);
                commit('SET_FILTER_STATUS', false);
            })
            .catch((error) => {
                commit('SET_UNRECONCILED_ITEMS', { data: [], meta: {} });
                commit('SET_FILTER_STATUS', false);
                let errorMsg = 'Failed to load unreconciled items.';
                if (error.response && error.response.data && error.response.data.message) {
                    errorMsg = error.response.data.message;
                }
                dispatch('notification/error', { msg: errorMsg }, { root: true });
            });
    },

};